export class AuthorizedError extends Error {
  constructor(
    message: string,
    public pageTitle: string
  ) {
    super(message);
    // Ensure the correct prototype chain
    Object.setPrototypeOf(this, new.target.prototype);

    // Validate pageTitle
    if (!pageTitle) {
      throw new Error("pageTitle is required");
    }
  }
}
